const DirectorDesk = () => {
    return (
        <div id="director" className="about-message container">
            <div className="message-left">
                <img src="https://picsum.photos/300/350" alt="director" />
            </div>

            <div className="message-right">
                <h2>DIRECTOR'S DESK</h2>
                <p>
                    Education is the foundation of progress. Our mission is to empower
                    every student with confidence, wisdom, and ethics.
                </p>
                <h4>- Director -</h4>
            </div>
        </div>

    );
};

export default DirectorDesk;